// Module
var code = `<template>
  <require from="./alert-modal.scss"></require>

  <mdc-dialog class="alert-modal">
    <button mdc-icon-button class="alert-modal__close" icon="close" data-mdc-dialog-action="close" if.bind="payload.showCloseButton"></button>
    <mdc-dialog-title if.bind="payload.caption">
      <mdc-icon class="\${payload.iconColour}">\${payload.icon}</mdc-icon>
      \${payload.caption}
    </mdc-dialog-title>
    <mdc-dialog-content class="alert-modal__dialog-content">
      <mdc-icon if.bind="!payload.caption" class="\${payload.iconColour}">\${payload.icon}</mdc-icon>
      <span if.bind="payload.message">\${payload.message}</span>
      <div if.bind="payload.html" innerhtml.bind="payload.html"></div>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <template if.bind="payload.button1Action === payload.defaultAction">
        <button mdc-button outlined data-mdc-dialog-action.bind="payload.button1Action" data-mdc-dialog-button-default data-mdc-dialog-initial-focus if.bind="payload.button1Text">\${payload.button1Text}</button>
      </template>
      <template else>
        <button mdc-button outlined data-mdc-dialog-action.bind="payload.button1Action" if.bind="payload.button1Text">\${payload.button1Text}</button>
      </template>

      <div if.bind="payload.button1OnLeft" class="mdc-dialog__action-spacer"></div>

      <template if.bind="payload.button2Action === payload.defaultAction">
        <button mdc-button raised data-mdc-dialog-action.bind="payload.button2Action" data-mdc-dialog-button-default data-mdc-dialog-initial-focus if.bind="payload.button2Text">\${payload.button2Text}</button>
      </template>
      <template else>
        <button mdc-button raised data-mdc-dialog-action.bind="payload.button2Action" if.bind="payload.button2Text">\${payload.button2Text}</button>
      </template>

      <template if.bind="payload.button3Action === payload.defaultAction">
        <button mdc-button raised data-mdc-dialog-action.bind="payload.button3Action" data-mdc-dialog-button-default data-mdc-dialog-initial-focus if.bind="payload.button3Text">\${payload.button3Text}</button>
      </template>
      <template else>
        <button mdc-button raised data-mdc-dialog-action.bind="payload.button3Action" if.bind="payload.button3Text">\${payload.button3Text}</button>
      </template>

    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;